import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { AppView } from 'medua-components';

import { history } from '../../../../store';

/* eslint-disable */
@translate(['account'])
export default class AccountLegalLicense extends Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  handleBack() {
    history.push('/account/legal')
  }

  render() {
    return (
      <AppView
        color="dark"
        title={ this.props.t('account:legal.license.title') }
        headerActionLeft={[
          { key: 1, icon: 'arrow-left', action: this.handleBack }
        ]} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/account/legal/license/index.jsx